import { render } from "./BoothLogin.vue?vue&type=template&id=2970e4a0&scoped=true"
import script from "./BoothLogin.vue?vue&type=script&lang=js"
export * from "./BoothLogin.vue?vue&type=script&lang=js"

import "./BoothLogin.vue?vue&type=style&index=0&id=2970e4a0&lang=scss&scoped=true"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2970e4a0"]])

export default __exports__